module.exports = __webpack_public_path__ + "static/media/bscBUSD.8705fd81.svg";